export const MAP_STYLE = process.env.REACT_APP_MAP_STYLE || "";
export const MAP_TOKEN = process.env.REACT_APP_MAP_TOKEN || "";
export const APP_ASSETS = process.env.REACT_APP_ASSET_URL || "";
export const BEETLE_MAP_ID = process.env.REACT_APP_BEETLE_MAP_ID || "";

const venueWith3DModel = ["venue_elements", "venue_xiqu_centre"];

const venueData = [
  {
    code: "mplus",
    name: "venue_m_plus",
    center: {
      lat: 22.30083235,
      lng: 114.1591653,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1586267, 22.3002013],
          [114.1585899, 22.3007032],
          [114.1585889, 22.3007167],
          [114.1585396, 22.3013906],
          [114.1596983, 22.3014634],
          [114.159791, 22.3002743],
          [114.1597565, 22.3002721],
          [114.1591742, 22.3002356],
          [114.1587321, 22.3002079],
          [114.1586267, 22.3002013],
        ],
      ],
    },
    model: {
      source: 'https://assets.deepworldmodel.ai/google_model/m_plus/m_plus_20260223_1300.glb',
      center: {
        lat: 22.301135088001047,
        lng: 114.1590364018362,
        altitude: 0,
      },
      name: {
        en: "M+",
        zh: "M+"
      }
    }
  },
  {
    code: "kowloon",
    name: "venue_kowloon_station",
    center: {
      lat: 22.3053,
      lng: 114.1616,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1629246, 22.3058861],
          [114.1621037, 22.3040764],
          [114.1617867, 22.3033852],
          [114.1600681, 22.3040279],
          [114.1601896, 22.304299],
          [114.1602546, 22.3044439],
          [114.1606779, 22.3042928],
          [114.1606443, 22.3042159],
          [114.1606753, 22.3042051],
          [114.1607777, 22.3041738],
          [114.1607895, 22.3041681],
          [114.1610913, 22.3048867],
          [114.1612739, 22.305305],
          [114.1615579, 22.3059712],
          [114.1615427, 22.3059766],
          [114.1615004, 22.3059903],
          [114.1615375, 22.3060796],
          [114.161175, 22.3062131],
          [114.160803, 22.3053954],
          [114.1606956, 22.3054368],
          [114.1607256, 22.3055041],
          [114.1609306, 22.305965],
          [114.1610641, 22.3062519],
          [114.1610848, 22.3062979],
          [114.161195, 22.3065394],
          [114.1612005, 22.3065514],
          [114.1624164, 22.3060822],
          [114.1629246, 22.3058861],
        ],
      ],
    },
    model: {
      name: {
        en: "Kowloon Station",
        zh: "九龍站"
      }
    }
  },
  {
    code: "elements",
    name: "venue_elements",
    center: {
      lat: 22.3049, // 22.30491185,
      lng: 114.1614, // 114.1616615,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1605633, 22.3051394],
          [114.1606749, 22.3050969],
          [114.1606989, 22.3051506],
          [114.1607211, 22.3052064],
          [114.1608064, 22.3051747],
          [114.1608359, 22.3052426],
          [114.1608558, 22.3052886],
          [114.1607689, 22.3053209],
          [114.1607837, 22.3053522],
          [114.160803, 22.3053954],
          [114.1606956, 22.3054368],
          [114.1607256, 22.3055041],
          [114.1609306, 22.305965],
          [114.1610641, 22.3062519],
          [114.1610848, 22.3062979],
          [114.161195, 22.3065394],
          [114.1612005, 22.3065514],
          [114.1612231, 22.3065965],
          [114.1612285, 22.3066092],
          [114.1612359, 22.3066237],
          [114.1612471, 22.3066523],
          [114.1612585, 22.3066795],
          [114.1612668, 22.3067],
          [114.1612762, 22.3067234],
          [114.1613346, 22.3068367],
          [114.1613575, 22.3068682],
          [114.161385, 22.3068963],
          [114.1614165, 22.3069206],
          [114.1614514, 22.3069406],
          [114.161489, 22.3069559],
          [114.1615285, 22.3069661],
          [114.1615691, 22.3069711],
          [114.1616102, 22.3069708],
          [114.1616507, 22.3069652],
          [114.1621381, 22.3068104],
          [114.1625892, 22.3067055],
          [114.1626561, 22.3066913],
          [114.163278, 22.3065622],
          [114.163476, 22.3064954],
          [114.1635053, 22.3064855],
          [114.1635402, 22.3064735],
          [114.1635567, 22.3064508],
          [114.1635664, 22.3064375],
          [114.1635642, 22.3063666],
          [114.163557, 22.3057433],
          [114.1635124, 22.304953],
          [114.1635114, 22.304896],
          [114.1635105, 22.3048407],
          [114.1634934, 22.3039666],
          [114.1634924, 22.3039142],
          [114.1634893, 22.3037524],
          [114.1634817, 22.3033555],
          [114.1634757, 22.3030458],
          [114.1634703, 22.3030189],
          [114.1634581, 22.3029935],
          [114.1634495, 22.3029829],
          [114.16344, 22.3029714],
          [114.1634195, 22.3029547],
          [114.1633899, 22.3029413],
          [114.1633605, 22.302935],
          [114.1628524, 22.302911],
          [114.1624035, 22.3028973],
          [114.1622682, 22.3028934],
          [114.162015, 22.3028862],
          [114.1617401, 22.3028804],
          [114.1615058, 22.3029125],
          [114.1615074, 22.3028755],
          [114.1610003, 22.3028649],
          [114.1605942, 22.3028555],
          [114.1605315, 22.3028555],
          [114.1604309, 22.3028555],
          [114.1603568, 22.3028526],
          [114.1602827, 22.3028542],
          [114.1602476, 22.3028572],
          [114.1602077, 22.3028606],
          [114.1601683, 22.3028664],
          [114.1601289, 22.3028723],
          [114.16005, 22.3028896],
          [114.1599985, 22.3029057],
          [114.15995, 22.3029282],
          [114.1599052, 22.3029566],
          [114.1598651, 22.3029905],
          [114.1598305, 22.3030292],
          [114.1598019, 22.303072],
          [114.1597776, 22.3031242],
          [114.1597624, 22.3031792],
          [114.1597566, 22.3032358],
          [114.1597604, 22.3032926],
          [114.1597737, 22.303348],
          [114.1598995, 22.3036356],
          [114.1599232, 22.3036899],
          [114.1599696, 22.3037959],
          [114.159987, 22.3038357],
          [114.1599929, 22.3038534],
          [114.160008, 22.3038916],
          [114.1600125, 22.3039033],
          [114.160048, 22.303984],
          [114.1600523, 22.3039933],
          [114.1600633, 22.3040175],
          [114.1600681, 22.3040279],
          [114.1601896, 22.304299],
          [114.1602546, 22.3044439],
          [114.1602692, 22.3044768],
          [114.1603243, 22.3046021],
          [114.1603311, 22.3046175],
          [114.1605363, 22.3050788],
          [114.1605633, 22.3051394],
        ],
      ],
    },
    model: {
      fullVideo: 'https://assets.deepworldmodel.ai/preview_video/elements_full.mp4',
      video: 'https://assets.deepworldmodel.ai/preview_video/elements480.mov',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/elements_preview.png',
      name: {
        en: "Elements",
        zh: "圓方"
      }
    }
  },
  {
    code: "austin",
    name: "venue_austin_station",
    center: {
      lat: 22.30454035,
      lng: 114.1664803,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1664613, 22.3042371],
          [114.1667097, 22.3043544],
          [114.1667235, 22.304328],
          [114.1670707, 22.3036636],
          [114.1670778, 22.3036501],
          [114.167313, 22.3032],
          [114.1673372, 22.3031536],
          [114.1671945, 22.3031503],
          [114.166721, 22.3031393],
          [114.1666996, 22.3034827],
          [114.1666749, 22.3038401],
          [114.1666735, 22.3038601],
          [114.1664613, 22.3042371],
        ],
        [
          [114.1662124, 22.3047171],
          [114.1660464, 22.3050281],
          [114.1658333, 22.3054273],
          [114.1658083, 22.3054742],
          [114.1656234, 22.3058205],
          [114.1657671, 22.3058897],
          [114.1658792, 22.3059414],
          [114.1660171, 22.3056807],
          [114.1662284, 22.3052814],
          [114.1662934, 22.305313],
          [114.1663429, 22.3052203],
          [114.1663489, 22.3052092],
          [114.1663956, 22.3051217],
          [114.1663298, 22.3050862],
          [114.1664636, 22.3048247],
          [114.1662124, 22.3047171],
        ],
      ],
    },
    model: {
      name: {
        en: "Austin Station",
        zh: "柯士甸站"
      }
    }
  },
  {
    code: "xiqu",
    name: "venue_xiqu_centre",
    center: {
      lat: 22.30215795,
      lng: 114.16721385,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1667633, 22.3023546],
          [114.1667653, 22.3023723],
          [114.1667706, 22.3023894],
          [114.1667785, 22.302405],
          [114.1667886, 22.3024197],
          [114.1668, 22.3024321],
          [114.1668168, 22.3024451],
          [114.166833, 22.3024545],
          [114.1668509, 22.3024615],
          [114.1668692, 22.3024658],
          [114.1668905, 22.3024678],
          [114.1671004, 22.3024802],
          [114.1674512, 22.3025009],
          [114.1675328, 22.3025057],
          [114.1675502, 22.3025055],
          [114.1675644, 22.3025036],
          [114.1675804, 22.3024989],
          [114.1675948, 22.3024927],
          [114.1676104, 22.3024842],
          [114.1676233, 22.3024745],
          [114.1676348, 22.3024626],
          [114.1676471, 22.3024464],
          [114.1676555, 22.3024307],
          [114.1676608, 22.3024153],
          [114.1676643, 22.302396],
          [114.1676644, 22.3023786],
          [114.1676613, 22.302359],
          [114.1675388, 22.3019595],
          [114.1675301, 22.3019384],
          [114.1675192, 22.3019199],
          [114.1675073, 22.3019043],
          [114.1674914, 22.3018881],
          [114.1674705, 22.3018719],
          [114.1674488, 22.3018594],
          [114.1674257, 22.3018494],
          [114.1674083, 22.3018449],
          [114.1673886, 22.3018423],
          [114.1669388, 22.3018102],
          [114.166919, 22.3018103],
          [114.1668989, 22.3018128],
          [114.1668799, 22.3018181],
          [114.16686, 22.3018269],
          [114.1668394, 22.3018412],
          [114.1668245, 22.3018562],
          [114.1668133, 22.3018727],
          [114.1668052, 22.3018905],
          [114.1667995, 22.3019159],
          [114.1667633, 22.3023546],
        ],
      ],
    },
    model: {
      source: 'https://assets.deepworldmodel.ai/google_model/xiqu/xiqu_model.glb',
      center: {
        lat: 22.30215795,
        lng: 114.16721385,
        altitude: 0,
      },
      fullVideo: 'https://assets.deepworldmodel.ai/preview_video/xiqu_full.mp4',
      video: 'https://assets.deepworldmodel.ai/preview_video/xiqu480.mov',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/xiqu_preview.png',
      name: {
        en: "Xiqu Centre",
        zh: "戲曲中心"
      }
    }
  },
  {
    code: "westkowloonstation",
    name: "venue_west_kowloon_station",
    center: {
      lat: 22.3043,
      lng: 114.165,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.1648886, 22.3031018],
          [114.1649098, 22.3030861],
          [114.1649304, 22.3030707],
          [114.1649838, 22.3030311],
          [114.1650924, 22.3031676],
          [114.1651349, 22.3031419],
          [114.165193, 22.3031067],
          [114.1653177, 22.3032818],
          [114.1653192, 22.3032655],
          [114.1653568, 22.3032643],
          [114.1653581, 22.303242],
          [114.1653943, 22.303242],
          [114.1653956, 22.3032246],
          [114.1654453, 22.3032209],
          [114.1654681, 22.3031973],
          [114.165527, 22.3032147],
          [114.1655754, 22.3031998],
          [114.1656986, 22.3032507],
          [114.165798, 22.3032593],
          [114.1658394, 22.3032867],
          [114.1658784, 22.3032556],
          [114.1659199, 22.3032904],
          [114.1659558, 22.303287],
          [114.1659938, 22.3032817],
          [114.1659991, 22.303299],
          [114.1660487, 22.3032867],
          [114.16605, 22.3033252],
          [114.1661557, 22.3033344],
          [114.1661289, 22.3035551],
          [114.1660935, 22.3038193],
          [114.1660664, 22.3039758],
          [114.1660246, 22.3041825],
          [114.1659776, 22.3043402],
          [114.1659012, 22.3045572],
          [114.1658246, 22.3047843],
          [114.1657484, 22.3047631],
          [114.1656867, 22.3049443],
          [114.1654776, 22.3053296],
          [114.1654232, 22.3054364],
          [114.1653239, 22.3055881],
          [114.165138, 22.3058365],
          [114.1649288, 22.3060896],
          [114.1648662, 22.3061648],
          [114.1648015, 22.3062272],
          [114.1647211, 22.3062496],
          [114.1643791, 22.3063215],
          [114.1643092, 22.3063178],
          [114.1642154, 22.306298],
          [114.1641644, 22.3062336],
          [114.1641482, 22.3061416],
          [114.1641402, 22.3060325],
          [114.1641524, 22.3055721],
          [114.1641484, 22.3054505],
          [114.1641471, 22.3052967],
          [114.1641444, 22.305247],
          [114.1641444, 22.3051503],
          [114.1641424, 22.3050138],
          [114.1641407, 22.3048283],
          [114.1641363, 22.30435],
          [114.1641353, 22.3042842],
          [114.1641347, 22.304244],
          [114.1641341, 22.3042048],
          [114.1641278, 22.3038029],
          [114.1641255, 22.3036515],
          [114.1641488, 22.3035532],
          [114.1641749, 22.3034434],
          [114.1641939, 22.3033636],
          [114.1642821, 22.3033697],
          [114.1643655, 22.3033748],
          [114.1643361, 22.3032978],
          [114.1644113, 22.3033077],
          [114.1643951, 22.3032358],
          [114.1644423, 22.3032266],
          [114.1644648, 22.3032222],
          [114.1644903, 22.3033215],
          [114.1645347, 22.3034194],
          [114.1645828, 22.3035125],
          [114.1646554, 22.3036117],
          [114.1646892, 22.3036453],
          [114.1647195, 22.3036812],
          [114.1647841, 22.3037408],
          [114.1648713, 22.3038102],
          [114.1649717, 22.3038835],
          [114.1650014, 22.3038822],
          [114.1650376, 22.303871],
          [114.1650698, 22.3038524],
          [114.1651154, 22.3038723],
          [114.1651556, 22.3038983],
          [114.1651836, 22.3039282],
          [114.1652361, 22.3038698],
          [114.1652562, 22.3038226],
          [114.1652749, 22.3037532],
          [114.165279, 22.3036862],
          [114.1652158, 22.3035758],
          [114.1651595, 22.3034815],
          [114.1650495, 22.3033152],
          [114.1648886, 22.3031018],
        ],
      ],
    },
    model: {
      source: 'https://assets.deepworldmodel.ai/google_model/west_kowloon_station/west_kowloon_station_20260226_1045.glb',
      center: {
        lat: 22.305189004120226,
        lng: 114.16465378897448,
        altitude: 0,
      },
      fullVideo: 'https://assets.deepworldmodel.ai/preview_video/westKowloonStation_full.mp4',
      video: 'https://assets.deepworldmodel.ai/preview_video/westkowloon480.mov',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/westkowloon_preview.png',
      name: {
        en: "West Kowloon Station",
        zh: "西九龍站"
      }
    }
  },
  {
    code: "palacemuseum",
    name: "venue_palace_museum",
    center: {
      lat: 22.3016322,
      lng: 114.15550895000001,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [114.15649, 22.3020031],
          [114.1564666, 22.3019286],
          [114.1563025, 22.3017258],
          [114.1562639, 22.3016785],
          [114.1562165, 22.3016196],
          [114.1561818, 22.3015693],
          [114.1561528, 22.301516],
          [114.1561243, 22.3014453],
          [114.1561056, 22.3013718],
          [114.1560969, 22.3012968],
          [114.1560984, 22.3012213],
          [114.155977, 22.3011876],
          [114.1559152, 22.3011874],
          [114.1558939, 22.3011873],
          [114.1558576, 22.3011873],
          [114.1557076, 22.3011817],
          [114.1555696, 22.301171],
          [114.1555089, 22.301164],
          [114.1554322, 22.3011551],
          [114.1552956, 22.3011342],
          [114.15516, 22.3011081],
          [114.1550257, 22.301077],
          [114.1548819, 22.3010513],
          [114.1547231, 22.3010931],
          [114.1546698, 22.301115],
          [114.1546173, 22.3011448],
          [114.1545693, 22.3011819],
          [114.1545279, 22.3012243],
          [114.1545285, 22.3013029],
          [114.1545538, 22.3013028],
          [114.1545597, 22.3020067],
          [114.1545784, 22.3020065],
          [114.1545925, 22.3020064],
          [114.1546073, 22.3020063],
          [114.1546994, 22.3020057],
          [114.1547144, 22.3020056],
          [114.1548572, 22.3020047],
          [114.1548574, 22.3020335],
          [114.155026, 22.3020324],
          [114.1550411, 22.3020323],
          [114.1557951, 22.3020272],
          [114.1557956, 22.3020702],
          [114.1557962, 22.302131],
          [114.1557968, 22.3021831],
          [114.1558299, 22.3022131],
          [114.1559916, 22.3022116],
          [114.1560571, 22.302211],
          [114.1561564, 22.3022101],
          [114.1563117, 22.302209],
          [114.1563583, 22.3022067],
          [114.1563988, 22.3021964],
          [114.1563997, 22.3021461],
          [114.1564023, 22.3020018],
          [114.1564217, 22.3020021],
          [114.1564411, 22.3020024],
          [114.15649, 22.3020031],
        ],
      ],
    },
    model: {
      source: 'https://assets.deepworldmodel.ai/google_model/palace_museum/palace_museum_20260223_1300.glb',
      center: {
        lat: 22.301599,
        lng: 114.154907,
        altitude: 0,
      },
      name: {
        en: "Palace Museum",
        zh: "故宮博物館"
      }
    }
  },
  {
    code: "admiraltystation",
    name: "venue_admiralty_station",
    center: {
      lat: 22.279419373414058,
      lng: 114.1644880056628,
    },
    geofence: {
      type: "Polygon",
      coordinates: [
        [
          [
            114.1660935,
            22.2787096
          ],
          [
            114.1653064,
            22.277884
          ],
          [
            114.1656064,
            22.2776277
          ],
          [
            114.1671356,
            22.2792598
          ],
          [
            114.1670576,
            22.2793229
          ],
          [
            114.1669707,
            22.2793126
          ],
          [
            114.1668732,
            22.2793495
          ],
          [
            114.1666348,
            22.2793451
          ],
          [
            114.1665906,
            22.2793301
          ],
          [
            114.1662553,
            22.279337
          ],
          [
            114.165924,
            22.2793556
          ],
          [
            114.1655914,
            22.279384
          ],
          [
            114.1652605,
            22.2794231
          ],
          [
            114.165263,
            22.2794705
          ],
          [
            114.1650114,
            22.2795052
          ],
          [
            114.1650053,
            22.2794643
          ],
          [
            114.1648369,
            22.2795715
          ],
          [
            114.1647831,
            22.2794984
          ],
          [
            114.1645756,
            22.2795359
          ],
          [
            114.1643694,
            22.279583
          ],
          [
            114.1641685,
            22.279639
          ],
          [
            114.1639711,
            22.2797039
          ],
          [
            114.163912,
            22.2794809
          ],
          [
            114.1640448,
            22.2794562
          ],
          [
            114.1640409,
            22.2794368
          ],
          [
            114.1640144,
            22.2794424
          ],
          [
            114.1639519,
            22.2793741
          ],
          [
            114.1640324,
            22.2793129
          ],
          [
            114.1641028,
            22.2793873
          ],
          [
            114.1643858,
            22.2793136
          ],
          [
            114.1643952,
            22.2793615
          ],
          [
            114.1644461,
            22.2793532
          ],
          [
            114.1644562,
            22.2793218
          ],
          [
            114.1645437,
            22.2792927
          ],
          [
            114.1645663,
            22.2793084
          ],
          [
            114.1650056,
            22.2791498
          ],
          [
            114.164788,
            22.278846
          ],
          [
            114.1647348,
            22.2785234
          ],
          [
            114.1647676,
            22.2785189
          ],
          [
            114.1647901,
            22.2785158
          ],
          [
            114.1648369,
            22.2787982
          ],
          [
            114.164841,
            22.2788229
          ],
          [
            114.1650653,
            22.2791351
          ],
          [
            114.1652164,
            22.2791042
          ],
          [
            114.1653558,
            22.2790521
          ],
          [
            114.1654414,
            22.2790136
          ],
          [
            114.1656119,
            22.2789421
          ],
          [
            114.1658437,
            22.2788263
          ],
          [
            114.1660935,
            22.2787096
          ]
        ]
      ]
    },
    model: {
      fullVideo: 'https://assets.deepworldmodel.ai/preview_video/admiraltyStation_full.mp4',
      video: 'https://assets.deepworldmodel.ai/preview_video/admiraltyStation480.mov',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/admiraltyStation_preview.png',
      name: {
        en: "Admiralty Station",
        zh: "金鐘站"
      }
    }
  },
  {
    code: "hkia",
    name: "venue_hkia",
    center: {
      lat: 22.314413644643693,
      lng: 113.91351398367999
    },
    "geofence": {
      "type": "Polygon",
      "coordinates": [
        [
          [
            113.9379944,
            22.3213987
          ],
          [
            113.9378539,
            22.3213965
          ],
          [
            113.9377393,
            22.3214247
          ],
          [
            113.9376422,
            22.3214819
          ],
          [
            113.9375662,
            22.3215524
          ],
          [
            113.9374962,
            22.3216655
          ],
          [
            113.9366154,
            22.3240358
          ],
          [
            113.9365351,
            22.3242118
          ],
          [
            113.9364415,
            22.3243401
          ],
          [
            113.9363175,
            22.3244625
          ],
          [
            113.9361577,
            22.3245975
          ],
          [
            113.9359858,
            22.3246986
          ],
          [
            113.9357914,
            22.3247771
          ],
          [
            113.9241312,
            22.3281297
          ],
          [
            113.9238637,
            22.3282051
          ],
          [
            113.9237404,
            22.3282534
          ],
          [
            113.9236568,
            22.3283134
          ],
          [
            113.9235564,
            22.3283926
          ],
          [
            113.9234854,
            22.328468
          ],
          [
            113.9234143,
            22.3285859
          ],
          [
            113.9233219,
            22.3288038
          ],
          [
            113.9221082,
            22.3322279
          ],
          [
            113.9219422,
            22.3325034
          ],
          [
            113.9218482,
            22.3326097
          ],
          [
            113.9216956,
            22.3327315
          ],
          [
            113.9215096,
            22.3328513
          ],
          [
            113.9213717,
            22.3329287
          ],
          [
            113.9212296,
            22.3329944
          ],
          [
            113.9211272,
            22.3330079
          ],
          [
            113.9208889,
            22.3330234
          ],
          [
            113.9207343,
            22.3330234
          ],
          [
            113.9203393,
            22.3329403
          ],
          [
            113.9202013,
            22.3329113
          ],
          [
            113.9201052,
            22.3329151
          ],
          [
            113.9199694,
            22.3329461
          ],
          [
            113.9198272,
            22.3330118
          ],
          [
            113.9197457,
            22.3330562
          ],
          [
            113.9196538,
            22.3331548
          ],
          [
            113.9195911,
            22.3332264
          ],
          [
            113.9195375,
            22.3333241
          ],
          [
            113.9192024,
            22.334207
          ],
          [
            113.9191506,
            22.3343118
          ],
          [
            113.919094,
            22.3343977
          ],
          [
            113.9190063,
            22.3345059
          ],
          [
            113.9188683,
            22.3346219
          ],
          [
            113.918745,
            22.3347089
          ],
          [
            113.9185925,
            22.3347978
          ],
          [
            113.9184002,
            22.3348771
          ],
          [
            113.9182372,
            22.3349196
          ],
          [
            113.918093,
            22.3349196
          ],
          [
            113.9179195,
            22.3349099
          ],
          [
            113.9177604,
            22.3348992
          ],
          [
            113.9176083,
            22.334864
          ],
          [
            113.9143861,
            22.3338264
          ],
          [
            113.9142617,
            22.3337929
          ],
          [
            113.9141391,
            22.3337941
          ],
          [
            113.9137772,
            22.3338423
          ],
          [
            113.9135819,
            22.3338489
          ],
          [
            113.9134168,
            22.3338296
          ],
          [
            113.9132935,
            22.3337986
          ],
          [
            113.9100972,
            22.3327667
          ],
          [
            113.9099053,
            22.3326975
          ],
          [
            113.9097564,
            22.3326087
          ],
          [
            113.9095826,
            22.3324742
          ],
          [
            113.9093862,
            22.3322741
          ],
          [
            113.9092853,
            22.3321936
          ],
          [
            113.9091339,
            22.3321313
          ],
          [
            113.886006,
            22.3246769
          ],
          [
            113.8858591,
            22.3246343
          ],
          [
            113.8857048,
            22.3246065
          ],
          [
            113.8855731,
            22.3246134
          ],
          [
            113.8853552,
            22.3246426
          ],
          [
            113.8851539,
            22.3246683
          ],
          [
            113.8849614,
            22.3246541
          ],
          [
            113.8847312,
            22.3245954
          ],
          [
            113.8815177,
            22.3235497
          ],
          [
            113.8813489,
            22.3234772
          ],
          [
            113.8811948,
            22.3233808
          ],
          [
            113.8810671,
            22.3232673
          ],
          [
            113.8809299,
            22.3231214
          ],
          [
            113.8807831,
            22.3230099
          ],
          [
            113.8805905,
            22.3229352
          ],
          [
            113.8803697,
            22.3228633
          ],
          [
            113.8774732,
            22.3219412
          ],
          [
            113.8772284,
            22.321839
          ],
          [
            113.8769931,
            22.3216703
          ],
          [
            113.8767963,
            22.3214615
          ],
          [
            113.8766426,
            22.3212705
          ],
          [
            113.876585,
            22.3210573
          ],
          [
            113.876537,
            22.3208308
          ],
          [
            113.8765466,
            22.3206132
          ],
          [
            113.876609,
            22.3204
          ],
          [
            113.8776695,
            22.3175694
          ],
          [
            113.8777415,
            22.3174361
          ],
          [
            113.8778231,
            22.317334
          ],
          [
            113.8779288,
            22.3172407
          ],
          [
            113.8780536,
            22.3171208
          ],
          [
            113.878212,
            22.3170364
          ],
          [
            113.8784089,
            22.3169609
          ],
          [
            113.8786538,
            22.3169076
          ],
          [
            113.8788554,
            22.3168765
          ],
          [
            113.8790042,
            22.3168942
          ],
          [
            113.8792971,
            22.3169653
          ],
          [
            113.8979357,
            22.3229818
          ],
          [
            113.8980367,
            22.3230072
          ],
          [
            113.8981959,
            22.3230356
          ],
          [
            113.8983754,
            22.3230387
          ],
          [
            113.8985553,
            22.3229867
          ],
          [
            113.8987163,
            22.3228917
          ],
          [
            113.8988575,
            22.3227455
          ],
          [
            113.8989404,
            22.3225688
          ],
          [
            113.9012537,
            22.3164978
          ],
          [
            113.9012997,
            22.316308
          ],
          [
            113.9012931,
            22.3161547
          ],
          [
            113.9012392,
            22.3159889
          ],
          [
            113.9011562,
            22.3158347
          ],
          [
            113.9010025,
            22.315697
          ],
          [
            113.9007895,
            22.3156039
          ],
          [
            113.8956945,
            22.314009
          ],
          [
            113.895353,
            22.3138851
          ],
          [
            113.8950975,
            22.3137429
          ],
          [
            113.8948507,
            22.3135816
          ],
          [
            113.8902873,
            22.3101079
          ],
          [
            113.8900817,
            22.3099412
          ],
          [
            113.8899435,
            22.3097295
          ],
          [
            113.8898145,
            22.3093762
          ],
          [
            113.8897932,
            22.3091166
          ],
          [
            113.8898133,
            22.3088986
          ],
          [
            113.8898673,
            22.3087163
          ],
          [
            113.8902794,
            22.307739
          ],
          [
            113.8904002,
            22.3075431
          ],
          [
            113.8905881,
            22.3073773
          ],
          [
            113.8907957,
            22.3072557
          ],
          [
            113.8910313,
            22.3071727
          ],
          [
            113.8912779,
            22.3071356
          ],
          [
            113.8958721,
            22.3071873
          ],
          [
            113.8959917,
            22.3071631
          ],
          [
            113.8960871,
            22.3071299
          ],
          [
            113.8961747,
            22.3070793
          ],
          [
            113.8962592,
            22.3070002
          ],
          [
            113.8963055,
            22.3068769
          ],
          [
            113.8969119,
            22.30519
          ],
          [
            113.8966852,
            22.3051168
          ],
          [
            113.8967349,
            22.3049902
          ],
          [
            113.8969964,
            22.3042184
          ],
          [
            113.8973518,
            22.3043326
          ],
          [
            113.8974671,
            22.30401
          ],
          [
            113.8980666,
            22.3023567
          ],
          [
            113.8980538,
            22.3022872
          ],
          [
            113.8980491,
            22.30225
          ],
          [
            113.8980438,
            22.3021947
          ],
          [
            113.8981068,
            22.3018424
          ],
          [
            113.8980854,
            22.301619
          ],
          [
            113.8979915,
            22.3013522
          ],
          [
            113.8971814,
            22.3002976
          ],
          [
            113.8944724,
            22.2968965
          ],
          [
            113.8941237,
            22.2964002
          ],
          [
            113.8939816,
            22.2960602
          ],
          [
            113.8938931,
            22.2957425
          ],
          [
            113.8938931,
            22.295266
          ],
          [
            113.8939574,
            22.2948987
          ],
          [
            113.8940835,
            22.2946443
          ],
          [
            113.894341,
            22.2943267
          ],
          [
            113.8947272,
            22.294009
          ],
          [
            113.8952798,
            22.2937348
          ],
          [
            113.8960469,
            22.2936405
          ],
          [
            113.8967657,
            22.2936405
          ],
          [
            113.8975328,
            22.2936356
          ],
          [
            113.8988525,
            22.2936455
          ],
          [
            113.8992199,
            22.2937026
          ],
          [
            113.9002284,
            22.2940078
          ],
          [
            113.9012008,
            22.294282
          ],
          [
            113.902334,
            22.2945563
          ],
          [
            113.9035141,
            22.2947833
          ],
          [
            113.9048392,
            22.2949732
          ],
          [
            113.9061829,
            22.2951196
          ],
          [
            113.9071137,
            22.2951742
          ],
          [
            113.9080417,
            22.295209
          ],
          [
            113.9106955,
            22.2951945
          ],
          [
            113.9116359,
            22.2952238
          ],
          [
            113.9132667,
            22.295132
          ],
          [
            113.9133096,
            22.2953306
          ],
          [
            113.9144851,
            22.2953306
          ],
          [
            113.9150661,
            22.2953306
          ],
          [
            113.9157227,
            22.2953306
          ],
          [
            113.9160991,
            22.2953306
          ],
          [
            113.9160991,
            22.2952114
          ],
          [
            113.9163059,
            22.2951967
          ],
          [
            113.9165558,
            22.2951789
          ],
          [
            113.9166578,
            22.2951618
          ],
          [
            113.9173436,
            22.2948938
          ],
          [
            113.9187169,
            22.2945364
          ],
          [
            113.9199703,
            22.2941585
          ],
          [
            113.9205833,
            22.2939737
          ],
          [
            113.9212495,
            22.2937729
          ],
          [
            113.9225364,
            22.2933849
          ],
          [
            113.9244002,
            22.292848
          ],
          [
            113.9272084,
            22.2920391
          ],
          [
            113.9289549,
            22.2914864
          ],
          [
            113.9290612,
            22.2915947
          ],
          [
            113.9306664,
            22.29111
          ],
          [
            113.9309736,
            22.2910172
          ],
          [
            113.9315959,
            22.2908293
          ],
          [
            113.9315818,
            22.29076
          ],
          [
            113.9315994,
            22.2907167
          ],
          [
            113.9316499,
            22.2906789
          ],
          [
            113.931804,
            22.2906146
          ],
          [
            113.9319368,
            22.2905852
          ],
          [
            113.9320347,
            22.2905332
          ],
          [
            113.9323402,
            22.2903126
          ],
          [
            113.9324858,
            22.2902504
          ],
          [
            113.9325598,
            22.2901847
          ],
          [
            113.9325983,
            22.290218
          ],
          [
            113.9325958,
            22.2902483
          ],
          [
            113.9333337,
            22.2904344
          ],
          [
            113.9335544,
            22.2904756
          ],
          [
            113.9337826,
            22.290564
          ],
          [
            113.9339385,
            22.2905699
          ],
          [
            113.9340086,
            22.2906017
          ],
          [
            113.9342229,
            22.2908453
          ],
          [
            113.9344951,
            22.2909978
          ],
          [
            113.9344653,
            22.2911105
          ],
          [
            113.9345409,
            22.2912446
          ],
          [
            113.9345304,
            22.2913044
          ],
          [
            113.9346512,
            22.2914289
          ],
          [
            113.9347532,
            22.2914835
          ],
          [
            113.9348011,
            22.2916075
          ],
          [
            113.9349813,
            22.2916878
          ],
          [
            113.9350827,
            22.2917011
          ],
          [
            113.9351314,
            22.2917409
          ],
          [
            113.9351191,
            22.291829
          ],
          [
            113.9351528,
            22.2918868
          ],
          [
            113.9354311,
            22.2920783
          ],
          [
            113.9355853,
            22.2922756
          ],
          [
            113.9356564,
            22.2923314
          ],
          [
            113.9357382,
            22.2923562
          ],
          [
            113.9358034,
            22.2925265
          ],
          [
            113.9359404,
            22.2926802
          ],
          [
            113.9359634,
            22.2927534
          ],
          [
            113.9360661,
            22.2927328
          ],
          [
            113.9360503,
            22.2928144
          ],
          [
            113.9360775,
            22.2928488
          ],
          [
            113.9362244,
            22.2928724
          ],
          [
            113.9364212,
            22.2930393
          ],
          [
            113.9364726,
            22.2930061
          ],
          [
            113.9365895,
            22.2931793
          ],
          [
            113.9366051,
            22.2931444
          ],
          [
            113.936685,
            22.2931838
          ],
          [
            113.9366976,
            22.2932596
          ],
          [
            113.9367643,
            22.2933272
          ],
          [
            113.9368122,
            22.2933998
          ],
          [
            113.9368666,
            22.2933806
          ],
          [
            113.9369613,
            22.2934023
          ],
          [
            113.9371532,
            22.2935863
          ],
          [
            113.9373584,
            22.293753
          ],
          [
            113.9374328,
            22.2938801
          ],
          [
            113.9375324,
            22.2939744
          ],
          [
            113.9381602,
            22.2945687
          ],
          [
            113.9383002,
            22.2946984
          ],
          [
            113.9383537,
            22.2947595
          ],
          [
            113.9383776,
            22.2947898
          ],
          [
            113.9383865,
            22.2948427
          ],
          [
            113.9383743,
            22.2948733
          ],
          [
            113.9382775,
            22.2949364
          ],
          [
            113.9381759,
            22.2950691
          ],
          [
            113.9375563,
            22.2961118
          ],
          [
            113.937377,
            22.296601
          ],
          [
            113.9371592,
            22.2975228
          ],
          [
            113.9372344,
            22.2978641
          ],
          [
            113.9371035,
            22.2980511
          ],
          [
            113.9370086,
            22.2984254
          ],
          [
            113.9370732,
            22.2985164
          ],
          [
            113.9368979,
            22.2989582
          ],
          [
            113.93681,
            22.2990967
          ],
          [
            113.936619,
            22.299395
          ],
          [
            113.9365538,
            22.2994898
          ],
          [
            113.9364973,
            22.299718
          ],
          [
            113.9365635,
            22.299851
          ],
          [
            113.93687,
            22.300324
          ],
          [
            113.9368271,
            22.3007925
          ],
          [
            113.9365421,
            22.3011336
          ],
          [
            113.9365049,
            22.3012415
          ],
          [
            113.9365261,
            22.3013836
          ],
          [
            113.9366115,
            22.3015796
          ],
          [
            113.9367078,
            22.3016987
          ],
          [
            113.9367148,
            22.301778
          ],
          [
            113.9368538,
            22.3019445
          ],
          [
            113.937049,
            22.3021716
          ],
          [
            113.9373933,
            22.3023007
          ],
          [
            113.9378695,
            22.3023599
          ],
          [
            113.9384967,
            22.302746
          ],
          [
            113.9391365,
            22.3027803
          ],
          [
            113.9393152,
            22.3028446
          ],
          [
            113.9395246,
            22.3030994
          ],
          [
            113.9396478,
            22.3031649
          ],
          [
            113.9400581,
            22.3035645
          ],
          [
            113.9400081,
            22.3036425
          ],
          [
            113.939931,
            22.3036797
          ],
          [
            113.9397743,
            22.3037312
          ],
          [
            113.9395519,
            22.3038857
          ],
          [
            113.9395153,
            22.3038508
          ],
          [
            113.9394961,
            22.30387
          ],
          [
            113.9395319,
            22.3039236
          ],
          [
            113.9394553,
            22.3040233
          ],
          [
            113.9394103,
            22.3040199
          ],
          [
            113.9393997,
            22.3040449
          ],
          [
            113.9395602,
            22.3041355
          ],
          [
            113.9396816,
            22.3042505
          ],
          [
            113.9396811,
            22.304655
          ],
          [
            113.9391887,
            22.3049967
          ],
          [
            113.938762,
            22.3051064
          ],
          [
            113.9385619,
            22.3053773
          ],
          [
            113.9386135,
            22.3054154
          ],
          [
            113.9386459,
            22.3055066
          ],
          [
            113.9386186,
            22.3055892
          ],
          [
            113.9388203,
            22.3058043
          ],
          [
            113.9388086,
            22.3058558
          ],
          [
            113.938802,
            22.3061041
          ],
          [
            113.9388911,
            22.3062753
          ],
          [
            113.9387915,
            22.3063385
          ],
          [
            113.9386177,
            22.3064082
          ],
          [
            113.9384422,
            22.3064444
          ],
          [
            113.9383604,
            22.3064363
          ],
          [
            113.9383931,
            22.3064686
          ],
          [
            113.9384263,
            22.3065158
          ],
          [
            113.9384435,
            22.3065672
          ],
          [
            113.9384416,
            22.3066353
          ],
          [
            113.9384153,
            22.3066871
          ],
          [
            113.9383785,
            22.3067207
          ],
          [
            113.9383256,
            22.30675
          ],
          [
            113.9382705,
            22.3067594
          ],
          [
            113.9382102,
            22.306748
          ],
          [
            113.9382431,
            22.3070847
          ],
          [
            113.9384561,
            22.3077917
          ],
          [
            113.9386197,
            22.3088243
          ],
          [
            113.938712,
            22.3093451
          ],
          [
            113.9388859,
            22.3098995
          ],
          [
            113.9390019,
            22.3101285
          ],
          [
            113.9391904,
            22.3105039
          ],
          [
            113.9393912,
            22.3108296
          ],
          [
            113.9396112,
            22.3111174
          ],
          [
            113.9403073,
            22.311899
          ],
          [
            113.9407655,
            22.3123974
          ],
          [
            113.9413153,
            22.3127998
          ],
          [
            113.941443,
            22.3129609
          ],
          [
            113.9420675,
            22.3138198
          ],
          [
            113.9422915,
            22.3141039
          ],
          [
            113.9423019,
            22.3141171
          ],
          [
            113.9423673,
            22.3142
          ],
          [
            113.9432767,
            22.3154458
          ],
          [
            113.9436073,
            22.3159495
          ],
          [
            113.9436458,
            22.3160162
          ],
          [
            113.94366,
            22.3160951
          ],
          [
            113.9437843,
            22.3165985
          ],
          [
            113.9438004,
            22.3167324
          ],
          [
            113.9438198,
            22.3167593
          ],
          [
            113.9438951,
            22.317087
          ],
          [
            113.9440012,
            22.3175762
          ],
          [
            113.9440034,
            22.3175865
          ],
          [
            113.9442289,
            22.3175477
          ],
          [
            113.944689,
            22.3174872
          ],
          [
            113.9447143,
            22.3176057
          ],
          [
            113.9442633,
            22.3177083
          ],
          [
            113.9440385,
            22.3177524
          ],
          [
            113.9441131,
            22.3181058
          ],
          [
            113.9443415,
            22.318074
          ],
          [
            113.9448049,
            22.3180082
          ],
          [
            113.9448191,
            22.3180728
          ],
          [
            113.9448333,
            22.3181375
          ],
          [
            113.9443774,
            22.318242
          ],
          [
            113.9441521,
            22.3182904
          ],
          [
            113.9442106,
            22.3185674
          ],
          [
            113.9449708,
            22.3184166
          ],
          [
            113.9449927,
            22.3185112
          ],
          [
            113.9442307,
            22.3186622
          ],
          [
            113.9443079,
            22.3190312
          ],
          [
            113.9443642,
            22.3192011
          ],
          [
            113.9444123,
            22.3193025
          ],
          [
            113.9444209,
            22.3193363
          ],
          [
            113.9445359,
            22.3194306
          ],
          [
            113.9448778,
            22.3197085
          ],
          [
            113.9451045,
            22.3197879
          ],
          [
            113.9450602,
            22.3199517
          ],
          [
            113.9449422,
            22.3199306
          ],
          [
            113.9447799,
            22.3201266
          ],
          [
            113.9447638,
            22.3202246
          ],
          [
            113.9447799,
            22.3202879
          ],
          [
            113.9448228,
            22.3203537
          ],
          [
            113.9449167,
            22.3203872
          ],
          [
            113.9450334,
            22.3203921
          ],
          [
            113.9459682,
            22.3203834
          ],
          [
            113.9460426,
            22.3197656
          ],
          [
            113.9460674,
            22.3197638
          ],
          [
            113.9459896,
            22.3194914
          ],
          [
            113.9458381,
            22.3194865
          ],
          [
            113.9457905,
            22.319484
          ],
          [
            113.9457583,
            22.3194679
          ],
          [
            113.9457516,
            22.3194468
          ],
          [
            113.945765,
            22.3194201
          ],
          [
            113.9458334,
            22.3194089
          ],
          [
            113.9460272,
            22.319422
          ],
          [
            113.9460674,
            22.3194313
          ],
          [
            113.9460895,
            22.3194827
          ],
          [
            113.9461425,
            22.3197135
          ],
          [
            113.9461505,
            22.3198177
          ],
          [
            113.9460754,
            22.3204083
          ],
          [
            113.9459681,
            22.3207134
          ],
          [
            113.9458823,
            22.3208332
          ],
          [
            113.9457683,
            22.3208549
          ],
          [
            113.9457254,
            22.3208865
          ],
          [
            113.9457133,
            22.3209368
          ],
          [
            113.9457187,
            22.3209839
          ],
          [
            113.9457556,
            22.3209827
          ],
          [
            113.9457549,
            22.3210807
          ],
          [
            113.9458153,
            22.3210794
          ],
          [
            113.9459628,
            22.3228225
          ],
          [
            113.9457998,
            22.3228274
          ],
          [
            113.9457187,
            22.3228796
          ],
          [
            113.9456825,
            22.3229453
          ],
          [
            113.9456785,
            22.3230173
          ],
          [
            113.9457053,
            22.3231686
          ],
          [
            113.9456718,
            22.3232368
          ],
          [
            113.9456034,
            22.3233138
          ],
          [
            113.9451849,
            22.3234639
          ],
          [
            113.945079,
            22.3235271
          ],
          [
            113.9449999,
            22.3236053
          ],
          [
            113.9449489,
            22.3236686
          ],
          [
            113.944957,
            22.3237666
          ],
          [
            113.9447223,
            22.3237839
          ],
          [
            113.9447021,
            22.3236351
          ],
          [
            113.9445526,
            22.3235556
          ],
          [
            113.9441711,
            22.3232716
          ],
          [
            113.9437285,
            22.3228498
          ],
          [
            113.943585,
            22.3226885
          ],
          [
            113.9434858,
            22.3226203
          ],
          [
            113.9433396,
            22.3225607
          ],
          [
            113.9395952,
            22.3218474
          ],
          [
            113.9392319,
            22.3217854
          ],
          [
            113.939071,
            22.3217432
          ],
          [
            113.9379944,
            22.3213987
          ]
        ]
      ]
    },
    model: {
      fullVideo: 'https://assets.deepworldmodel.ai/preview_video/hkia_full.mp4',
      video: 'https://assets.deepworldmodel.ai/preview_video/hkia_short.mp4',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/hkia_preview.png',
      name: {
        en: "Hong Kong International Airport",
        zh: "香港國際機場"
      }
    }
  },
  {
    code: "hkust",
    name: "venue_hkust",
    center: {
      lat: 22.3361008,
      lng: 114.2657368
    },
    "geofence": {
      "type": "Polygon",
      "coordinates": [
        [
          [
            114.2658947,
            22.3401869
          ],
          [
            114.2660312,
            22.3400666
          ],
          [
            114.2661425,
            22.3399748
          ],
          [
            114.2662538,
            22.3399178
          ],
          [
            114.2663517,
            22.3398396
          ],
          [
            114.2664304,
            22.3397011
          ],
          [
            114.2665176,
            22.3395076
          ],
          [
            114.2665716,
            22.3393508
          ],
          [
            114.2665891,
            22.339197
          ],
          [
            114.2666244,
            22.3389931
          ],
          [
            114.2666571,
            22.3388997
          ],
          [
            114.2667027,
            22.3387794
          ],
          [
            114.2667543,
            22.3386523
          ],
          [
            114.2668059,
            22.3385599
          ],
          [
            114.2668468,
            22.3384749
          ],
          [
            114.2668957,
            22.3383993
          ],
          [
            114.2669595,
            22.3383446
          ],
          [
            114.2670118,
            22.3383167
          ],
          [
            114.2670581,
            22.3383074
          ],
          [
            114.2671113,
            22.3383121
          ],
          [
            114.2672073,
            22.3383497
          ],
          [
            114.2672637,
            22.3383668
          ],
          [
            114.2673176,
            22.3383744
          ],
          [
            114.2673665,
            22.3383645
          ],
          [
            114.2674054,
            22.3383341
          ],
          [
            114.267443,
            22.3382832
          ],
          [
            114.2674845,
            22.338215
          ],
          [
            114.2675208,
            22.3381679
          ],
          [
            114.267555,
            22.338148
          ],
          [
            114.2676047,
            22.3381239
          ],
          [
            114.2676998,
            22.3380947
          ],
          [
            114.26785,
            22.3380482
          ],
          [
            114.2681692,
            22.3379675
          ],
          [
            114.2684019,
            22.3379154
          ],
          [
            114.2686634,
            22.3378472
          ],
          [
            114.2688793,
            22.3377926
          ],
          [
            114.2689852,
            22.3377652
          ],
          [
            114.2689953,
            22.3377967
          ],
          [
            114.268888,
            22.3378218
          ],
          [
            114.2688951,
            22.3378491
          ],
          [
            114.269003,
            22.3378274
          ],
          [
            114.2690053,
            22.3378361
          ],
          [
            114.2689802,
            22.3378407
          ],
          [
            114.2689893,
            22.3378754
          ],
          [
            114.2688328,
            22.337913
          ],
          [
            114.268844,
            22.3379682
          ],
          [
            114.2690241,
            22.337925
          ],
          [
            114.269384,
            22.3378398
          ],
          [
            114.2694097,
            22.3379016
          ],
          [
            114.2695747,
            22.3378585
          ],
          [
            114.2695449,
            22.3377408
          ],
          [
            114.2695826,
            22.3377216
          ],
          [
            114.2695472,
            22.3375898
          ],
          [
            114.2694908,
            22.3374141
          ],
          [
            114.2694205,
            22.3372314
          ],
          [
            114.269271,
            22.336823
          ],
          [
            114.269329,
            22.3368098
          ],
          [
            114.2693927,
            22.3367927
          ],
          [
            114.2694675,
            22.3367927
          ],
          [
            114.2695543,
            22.3368064
          ],
          [
            114.2696805,
            22.3368384
          ],
          [
            114.2697878,
            22.3368345
          ],
          [
            114.2698722,
            22.3368109
          ],
          [
            114.2698967,
            22.3367713
          ],
          [
            114.269904,
            22.3367204
          ],
          [
            114.2698814,
            22.3366575
          ],
          [
            114.2698174,
            22.336592
          ],
          [
            114.2697269,
            22.3364964
          ],
          [
            114.2696842,
            22.3364274
          ],
          [
            114.2696743,
            22.3363472
          ],
          [
            114.2694072,
            22.3363203
          ],
          [
            114.2688082,
            22.3336401
          ],
          [
            114.2665337,
            22.3317768
          ],
          [
            114.2661736,
            22.3321238
          ],
          [
            114.2658035,
            22.331849
          ],
          [
            114.2654354,
            22.3322507
          ],
          [
            114.2651789,
            22.3325278
          ],
          [
            114.2650605,
            22.3326597
          ],
          [
            114.2645048,
            22.3332788
          ],
          [
            114.2642092,
            22.3336082
          ],
          [
            114.2640806,
            22.3335228
          ],
          [
            114.2641915,
            22.3333913
          ],
          [
            114.2633065,
            22.3327679
          ],
          [
            114.2631662,
            22.3328487
          ],
          [
            114.2629388,
            22.332594
          ],
          [
            114.2628632,
            22.3326236
          ],
          [
            114.2629032,
            22.3328268
          ],
          [
            114.2624564,
            22.333019
          ],
          [
            114.2624919,
            22.3331051
          ],
          [
            114.2625198,
            22.3335508
          ],
          [
            114.2624234,
            22.3336322
          ],
          [
            114.2624037,
            22.3336755
          ],
          [
            114.2623528,
            22.3338943
          ],
          [
            114.2623092,
            22.3339149
          ],
          [
            114.262222,
            22.3339751
          ],
          [
            114.2621509,
            22.3340764
          ],
          [
            114.2620795,
            22.3342001
          ],
          [
            114.2619866,
            22.3344033
          ],
          [
            114.261979,
            22.3344459
          ],
          [
            114.2619855,
            22.3345025
          ],
          [
            114.262092,
            22.3350178
          ],
          [
            114.2620856,
            22.3350747
          ],
          [
            114.2621023,
            22.3351277
          ],
          [
            114.2621371,
            22.3351573
          ],
          [
            114.2621026,
            22.3353323
          ],
          [
            114.2620723,
            22.3353465
          ],
          [
            114.2620369,
            22.3353849
          ],
          [
            114.2620209,
            22.3354335
          ],
          [
            114.2620001,
            22.3360291
          ],
          [
            114.2620034,
            22.3361277
          ],
          [
            114.2620363,
            22.3361766
          ],
          [
            114.2620798,
            22.336217
          ],
          [
            114.262073,
            22.3364678
          ],
          [
            114.2620119,
            22.3365678
          ],
          [
            114.2619597,
            22.3367261
          ],
          [
            114.2619324,
            22.3368592
          ],
          [
            114.261914,
            22.3369844
          ],
          [
            114.2619415,
            22.3372229
          ],
          [
            114.2619053,
            22.3373403
          ],
          [
            114.261813,
            22.3375544
          ],
          [
            114.2616367,
            22.3379784
          ],
          [
            114.2615953,
            22.3381871
          ],
          [
            114.2615696,
            22.3384406
          ],
          [
            114.2616776,
            22.3385495
          ],
          [
            114.2617699,
            22.3386799
          ],
          [
            114.2618022,
            22.3387386
          ],
          [
            114.2617409,
            22.3388413
          ],
          [
            114.2619739,
            22.3389766
          ],
          [
            114.2620639,
            22.3392724
          ],
          [
            114.2621286,
            22.3394069
          ],
          [
            114.2623471,
            22.3395174
          ],
          [
            114.2624968,
            22.3397868
          ],
          [
            114.2625157,
            22.3399169
          ],
          [
            114.2624884,
            22.3400155
          ],
          [
            114.2624966,
            22.3401142
          ],
          [
            114.2627386,
            22.3403131
          ],
          [
            114.2627821,
            22.3403885
          ],
          [
            114.2628497,
            22.3404248
          ],
          [
            114.2629431,
            22.340395
          ],
          [
            114.2630071,
            22.340263
          ],
          [
            114.263296,
            22.3403457
          ],
          [
            114.2634687,
            22.3403952
          ],
          [
            114.2635868,
            22.3404101
          ],
          [
            114.2636755,
            22.3403812
          ],
          [
            114.2637282,
            22.3403454
          ],
          [
            114.2637849,
            22.3403087
          ],
          [
            114.2641211,
            22.3397953
          ],
          [
            114.2645247,
            22.3397805
          ],
          [
            114.2646038,
            22.3401129
          ],
          [
            114.2658947,
            22.3401869
          ]
        ]
      ]
    },
    model: {
      fullVideo: 'https://assets.deepworldmodel.ai/preview_video/hkust_full.mp4',
      video: 'https://assets.deepworldmodel.ai/preview_video/hkust_short.mp4',
      thumbnail: 'https://assets.deepworldmodel.ai/preview_video/hkust_preview.png',
      name: {
        en: "The Hong Kong University of Science and Technology",
        zh: "香港科技大學"
      }
    }
  },
];

export const findVenueCenter = (venueCode: string) => {
  const venue = venueData.find((eachVenue, index) => {
    return venueCode == eachVenue.code
  })
  if (venue) {
    return venue.center
  }
  return null;
}

export const findVenueFullVideo = (venueCode: string) => {
  const venue = venueData.find(
    (eachVenue) => eachVenue.code.toLowerCase() === venueCode.toLowerCase(),
  );
  return venue?.model?.fullVideo ?? "";
};

export const getVenueModels = () => {
  const modelList: any[] = [];

  venueData.map(venue => {
    if (venue.model && venue.model.source) {
      modelList.push(venue)
    }
  })
  return modelList;
}

export const getSupportedVenueData = () => {
  const venueList: any[] = [];
  venueData.map((eachVenue, index) => {
    const featureList: {
      type: string;
      properties: {
        code: string;
        name: string;
        center: { lat: number; lng: number };
        modelReady: boolean;
        modelPreviewVideo: string;
        modelPreviewThumbnail: string;
        modelFullVideo: string;
        modelName: { en: string, zh: string };
      };
      geometry: { type: string; coordinates: number[][] };
    }[] = [];
    eachVenue.geofence.coordinates.map((coords: any) => {
      return featureList.push({
        type: "Feature",
        properties: {
          code: eachVenue.code,
          name: eachVenue.name,
          center: eachVenue.center,
          modelReady: venueWith3DModel.includes(eachVenue.name) ? true : false,
          modelPreviewVideo: eachVenue.model?.video ?? '',
          modelPreviewThumbnail: eachVenue.model?.thumbnail ?? '',
          modelFullVideo: eachVenue.model?.fullVideo ?? '',
          modelName: eachVenue.model?.name
        },
        geometry: {
          type: "Polygon",
          coordinates: [coords],
        },
      });
    });
    const eachPolygon = {
      outterPolygon: eachVenue.geofence.coordinates[0] ?? [],
      center: eachVenue.center,
      type: "FeatureCollection",
      features: featureList,
      // [
      //   {
      //     type: "Feature",
      //     properties: {
      //       name: eachVenue.name
      //     },
      //     geometry: {
      //       type: "Polygon",
      //       coordinates: eachVenue.geofence.coordinates
      //     }
      //   }
      // ]
    };
    venueList.push(eachPolygon);
  });
  return venueList;
};
